/**
 * サンプル職業データ
 * アスリート向けに特化した職業情報（全109職種）
 */

import { CareerData } from '../services/matchingService';

export const sampleCareers: CareerData[] = [
  // ===== スポーツ指導系 =====
  {
    id: '1',
    name: 'スポーツ指導（インストラクター・コーチ）',
    category: 'スポーツ指導・トレーニング',
    description: '個人やチームに対してスポーツの技術指導やコーチングを行う仕事。自身の競技経験を直接活かせます。',
    riasecProfile: { R: 30, I: 5, A: 15, S: 35, E: 10, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['コミュニケーション力', '実行力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'インストラクター → チーフコーチ → ヘッドコーチ → 指導者育成',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上、関連資格があれば尚可',
    growthPotential: 'medium',
  },
  {
    id: '2',
    name: 'パーソナルトレーナー',
    category: 'スポーツ指導・トレーニング',
    description: '個別指導によりクライアントの健康・体力向上をサポート。スポーツ知識と対人スキルが求められます。',
    riasecProfile: { R: 35, I: 10, A: 10, S: 30, E: 10, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '独立性'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'パーソナルトレーナー → チーフトレーナー → 独立・開業',
    averageSalary: '300-600万円',
    requiredEducation: '高卒以上、NSCA-CPTなどの資格推奨',
    growthPotential: 'medium',
  },
  {
    id: '3',
    name: '体育教師',
    category: 'スポーツ指導・トレーニング',
    description: '学校で体育を教え、子どもたちの心身の成長をサポートする仕事。スポーツ経験を直接活かせます。',
    riasecProfile: { R: 25, I: 10, A: 10, S: 35, E: 10, C: 10 },
    requiredValues: ['社会貢献', '安定性', '人間関係'],
    requiredSkills: ['コミュニケーション力', '実行力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: '教諭 → 主任教諭 → 教頭 → 校長',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上、教員免許（保健体育）必須',
    growthPotential: 'medium',
  },
  {
    id: '4',
    name: 'アカデミー運営・育成スタッフ',
    category: 'スポーツ指導・トレーニング',
    description: 'スポーツアカデミーや育成組織の運営・指導を担当。次世代アスリートの発掘と育成に関わります。',
    riasecProfile: { R: 20, I: 10, A: 15, S: 25, E: 20, C: 10 },
    requiredValues: ['社会貢献', '達成感', '人間関係'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '育成スタッフ → アカデミーコーチ → アカデミーダイレクター',
    averageSalary: '350-600万円',
    requiredEducation: '大卒以上、指導経験者優遇',
    growthPotential: 'medium',
  },
  {
    id: '5',
    name: 'アスレティックトレーナー',
    category: 'スポーツ指導・トレーニング',
    description: 'スポーツ選手のケガ予防やリハビリ、コンディショニングを担当する専門職。',
    riasecProfile: { R: 30, I: 25, A: 5, S: 35, E: 5, C: 0 },
    requiredValues: ['社会貢献', '自己成長', '達成感'],
    requiredSkills: ['コミュニケーション力', '分析力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'トレーナー → チーフトレーナー → ヘッドトレーナー → 独立',
    averageSalary: '350-600万円',
    requiredEducation: '大卒以上、JATO-AT資格推奨',
    growthPotential: 'medium',
  },
  {
    id: '6',
    name: 'ストレングス＆コンディショニングコーチ',
    category: 'スポーツ指導・トレーニング',
    description: 'アスリートの筋力・体力強化プログラムを設計・指導する専門職。科学的知識と実践力が求められます。',
    riasecProfile: { R: 35, I: 15, A: 5, S: 30, E: 10, C: 5 },
    requiredValues: ['自己成長', '達成感', '社会貢献'],
    requiredSkills: ['分析力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'S&Cコーチ → ヘッドS&Cコーチ → パフォーマンスディレクター',
    averageSalary: '350-650万円',
    requiredEducation: '大卒以上、CSCS資格推奨',
    growthPotential: 'medium',
  },
  {
    id: '7',
    name: '部活動指導員',
    category: 'スポーツ指導・トレーニング',
    description: '学校の部活動で技術指導や運営を担当。教育的視点とスポーツ経験の両方が活かせます。',
    riasecProfile: { R: 30, I: 5, A: 15, S: 35, E: 10, C: 5 },
    requiredValues: ['社会貢献', '人間関係', '達成感'],
    requiredSkills: ['コミュニケーション力', '実行力', '計画力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: '部活動指導員 → 外部指導者 → 競技団体指導者',
    averageSalary: '250-400万円',
    requiredEducation: '高卒以上、競技経験者優遇',
    growthPotential: 'low',
  },
  // ===== 医療・健康系 =====
  {
    id: '8',
    name: 'スポーツ医療（理学療法士・柔道整復師・トレーナー）',
    category: '医療・健康・教育',
    description: 'スポーツ選手のリハビリやケアを提供する専門職。スポーツ経験が直接活かせます。',
    riasecProfile: { R: 30, I: 25, A: 5, S: 35, E: 5, C: 0 },
    requiredValues: ['社会貢献', '自己成長', '達成感'],
    requiredSkills: ['コミュニケーション力', '実行力', '分析力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'セラピスト → 主任 → リハビリ科長 → 独立開業',
    averageSalary: '350-600万円',
    requiredEducation: '理学療法士または柔道整復師免許',
    growthPotential: 'high',
  },
  {
    id: '9',
    name: 'スポーツドクター',
    category: '医療・健康・教育',
    description: 'スポーツ選手の怪我や健康管理を専門とする医師。高い医学知識とスポーツ理解が必要です。',
    riasecProfile: { R: 15, I: 45, A: 5, S: 25, E: 5, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '達成感'],
    requiredSkills: ['分析力', '問題発見力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '研修医 → 専門医 → スポーツドクター → チームドクター',
    averageSalary: '800-1500万円',
    requiredEducation: '医学部卒、医師免許必須',
    growthPotential: 'high',
  },
  {
    id: '10',
    name: '看護・介護・保育',
    category: '医療・健康・教育',
    description: '患者や利用者のケアを行う仕事。体力とメンタルタフネスが活かせます。',
    riasecProfile: { R: 20, I: 10, A: 10, S: 50, E: 5, C: 5 },
    requiredValues: ['社会貢献', '人間関係', '安定性'],
    requiredSkills: ['コミュニケーション力', '傾聴力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 3, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '看護師・介護士・保育士 → 主任 → 管理者 → 施設長',
    averageSalary: '300-550万円',
    requiredEducation: '各種国家資格必須',
    growthPotential: 'medium',
  },
  {
    id: '11',
    name: 'カウンセラー',
    category: '医療・健康・教育',
    description: '心理的なサポートを提供する専門職。傾聴力と共感力が求められます。',
    riasecProfile: { R: 5, I: 25, A: 15, S: 45, E: 5, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['傾聴力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 3, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'カウンセラー → スーパーバイザー → 独立開業',
    averageSalary: '350-600万円',
    requiredEducation: '大卒以上、臨床心理士等の資格',
    growthPotential: 'medium',
  },
  {
    id: '12',
    name: 'スクールカウンセラー',
    category: '医療・健康・教育',
    description: '学校現場で児童生徒の心理的支援を行う専門職。教育現場の理解と心理学の知識が必要です。',
    riasecProfile: { R: 5, I: 25, A: 15, S: 45, E: 5, C: 5 },
    requiredValues: ['社会貢献', '人間関係', '自己成長'],
    requiredSkills: ['傾聴力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 3, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'スクールカウンセラー → 常勤カウンセラー → 教育相談室長',
    averageSalary: '300-500万円',
    requiredEducation: '大卒以上、公認心理師・臨床心理士資格',
    growthPotential: 'medium',
  },
  {
    id: '13',
    name: '栄養士・パフォーマンス分析',
    category: '医療・健康・教育',
    description: '栄養管理やパフォーマンスデータの分析を通じて健康・競技力向上をサポートします。',
    riasecProfile: { R: 10, I: 35, A: 5, S: 25, E: 5, C: 20 },
    requiredValues: ['社会貢献', '自己成長', '安定性'],
    requiredSkills: ['分析力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '栄養士 → 管理栄養士 → 栄養管理部長',
    averageSalary: '350-550万円',
    requiredEducation: '管理栄養士免許',
    growthPotential: 'medium',
  },
  {
    id: '14',
    name: 'スポーツ栄養士',
    category: '医療・健康・教育',
    description: 'アスリートの栄養管理を専門に行う栄養士。競技特性に応じた食事プランを設計します。',
    riasecProfile: { R: 10, I: 35, A: 5, S: 25, E: 5, C: 20 },
    requiredValues: ['社会貢献', '自己成長', '達成感'],
    requiredSkills: ['分析力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '栄養士 → スポーツ栄養士 → チーム専属栄養士 → 独立',
    averageSalary: '350-600万円',
    requiredEducation: '管理栄養士免許、公認スポーツ栄養士推奨',
    growthPotential: 'medium',
  },
  // ===== スポーツビジネス系 =====
  {
    id: '15',
    name: 'スポーツビジネス（運営・スポンサー・メーカー）',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツ団体の運営やスポンサー営業、メーカーでの企画など幅広いビジネス領域で活躍します。',
    riasecProfile: { R: 15, I: 10, A: 15, S: 20, E: 30, C: 10 },
    requiredValues: ['達成感', '経済的報酬', '自己成長'],
    requiredSkills: ['コミュニケーション力', '交渉力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'スタッフ → マネージャー → 事業責任者 → 経営幹部',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '16',
    name: 'スポーツマーケティング',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツコンテンツを活用したマーケティング戦略を企画・実行する仕事。',
    riasecProfile: { R: 15, I: 10, A: 15, S: 20, E: 30, C: 10 },
    requiredValues: ['達成感', '自己成長', '経済的報酬'],
    requiredSkills: ['分析力', 'プレゼンテーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'アシスタント → マーケター → マーケティングマネージャー → CMO',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '17',
    name: 'スポーツ広報',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツチームや団体の広報活動を担当。メディア対応やブランディングを行います。',
    riasecProfile: { R: 15, I: 10, A: 15, S: 20, E: 30, C: 10 },
    requiredValues: ['達成感', '人間関係', '自己成長'],
    requiredSkills: ['コミュニケーション力', 'プレゼンテーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '広報スタッフ → 広報主任 → 広報マネージャー → 広報部長',
    averageSalary: '350-650万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '18',
    name: 'イベント企画・大会運営',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツイベントや大会の企画・運営を行う仕事。実行力とチームワークが重要です。',
    riasecProfile: { R: 15, I: 10, A: 25, S: 20, E: 25, C: 5 },
    requiredValues: ['達成感', '自己成長', '人間関係'],
    requiredSkills: ['計画力', 'コミュニケーション力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'アシスタント → プランナー → ディレクター → プロデューサー',
    averageSalary: '350-600万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '19',
    name: 'クラブ・施設運営',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツクラブやフィットネス施設の運営管理を行う仕事。経営感覚とスポーツ知識が必要です。',
    riasecProfile: { R: 20, I: 10, A: 10, S: 20, E: 25, C: 15 },
    requiredValues: ['達成感', '経済的報酬', '人間関係'],
    requiredSkills: ['計画力', 'コミュニケーション力', '実行力', '交渉力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: 'スタッフ → 主任 → 施設長 → エリアマネージャー',
    averageSalary: '350-650万円',
    requiredEducation: '高卒以上、経営知識があれば尚可',
    growthPotential: 'medium',
  },
  {
    id: '20',
    name: 'スカウト・マネジメント',
    category: 'スポーツビジネス・社会貢献',
    description: '才能ある選手の発掘やアスリートのマネジメントを行う仕事。目利き力と交渉力が重要です。',
    riasecProfile: { R: 10, I: 10, A: 10, S: 30, E: 30, C: 10 },
    requiredValues: ['達成感', '人間関係', '経済的報酬'],
    requiredSkills: ['コミュニケーション力', '交渉力', '分析力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'スカウト → チーフスカウト → 強化部長',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上、競技経験者優遇',
    growthPotential: 'medium',
  },
  {
    id: '21',
    name: 'スポーツエージェント',
    category: 'スポーツビジネス・社会貢献',
    description: 'アスリートの契約交渉やキャリア支援を行う代理人。法律知識と交渉力が必須です。',
    riasecProfile: { R: 10, I: 10, A: 10, S: 30, E: 30, C: 10 },
    requiredValues: ['経済的報酬', '達成感', '独立性'],
    requiredSkills: ['交渉力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'アシスタント → エージェント → シニアエージェント → 独立',
    averageSalary: '500-1500万円',
    requiredEducation: '大卒以上、法律知識推奨',
    growthPotential: 'high',
  },
  {
    id: '22',
    name: 'スポーツ行政・地域推進',
    category: 'スポーツビジネス・社会貢献',
    description: '行政機関でスポーツ振興政策や地域のスポーツ推進に携わる仕事。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 35, E: 15, C: 15 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['計画力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '担当者 → 主任 → 係長 → 課長',
    averageSalary: '400-650万円',
    requiredEducation: '大卒以上、公務員試験合格',
    growthPotential: 'medium',
  },
  // ===== メディア・発信系 =====
  {
    id: '23',
    name: '解説・ライター・メディア',
    category: 'メディア・クリエイティブ',
    description: 'スポーツの解説や記事執筆、メディア出演を行う仕事。競技知識と表現力が求められます。',
    riasecProfile: { R: 5, I: 30, A: 40, S: 15, E: 5, C: 5 },
    requiredValues: ['達成感', '独立性', '自己成長'],
    requiredSkills: ['コミュニケーション力', 'プレゼンテーション力', '分析力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: true,
    careerPath: 'ライター → コメンテーター → 解説者 → メディアパーソナリティ',
    averageSalary: '300-800万円',
    requiredEducation: '高卒以上、競技経験者優遇',
    growthPotential: 'medium',
  },
  {
    id: '24',
    name: 'SNS・YouTube・発信',
    category: 'メディア・クリエイティブ',
    description: 'SNSやYouTubeを活用して情報発信を行う仕事。自身のブランド構築と発信力が重要です。',
    riasecProfile: { R: 5, I: 15, A: 50, S: 20, E: 10, C: 0 },
    requiredValues: ['独立性', '達成感', '自己成長'],
    requiredSkills: ['プレゼンテーション力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 2, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '発信者 → インフルエンサー → メディアプロデューサー',
    averageSalary: '200-2000万円',
    requiredEducation: '不問',
    growthPotential: 'high',
  },
  {
    id: '25',
    name: '講演・教育活動',
    category: 'メディア・クリエイティブ',
    description: '講演会やセミナーで自身の経験を伝える仕事。プレゼンテーション力と人間的魅力が重要です。',
    riasecProfile: { R: 5, I: 15, A: 20, S: 40, E: 15, C: 5 },
    requiredValues: ['社会貢献', '達成感', '自己成長'],
    requiredSkills: ['プレゼンテーション力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '講演者 → 人気講演者 → 教育コンサルタント',
    averageSalary: '300-1000万円',
    requiredEducation: '不問、実績重視',
    growthPotential: 'medium',
  },
  {
    id: '26',
    name: 'コンテンツ制作',
    category: 'メディア・クリエイティブ',
    description: '動画・記事・番組などのコンテンツを企画・制作する仕事。創造性と技術力が必要です。',
    riasecProfile: { R: 10, I: 25, A: 45, S: 10, E: 5, C: 5 },
    requiredValues: ['達成感', '自己成長', '独立性'],
    requiredSkills: ['計画力', '実行力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'アシスタント → ディレクター → プロデューサー',
    averageSalary: '350-700万円',
    requiredEducation: '専門学校卒以上',
    growthPotential: 'high',
  },
  {
    id: '27',
    name: 'ポッドキャスト運営',
    category: 'メディア・クリエイティブ',
    description: 'ポッドキャスト番組の企画・制作・配信を行う仕事。トーク力と継続力が求められます。',
    riasecProfile: { R: 10, I: 25, A: 45, S: 10, E: 5, C: 5 },
    requiredValues: ['独立性', '達成感', '自己成長'],
    requiredSkills: ['コミュニケーション力', 'プレゼンテーション力', '計画力'],
    basicAbilities: { teamworkLevel: 2, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '運営者 → 人気ポッドキャスター → メディアプロデューサー',
    averageSalary: '200-800万円',
    requiredEducation: '不問',
    growthPotential: 'medium',
  },
  // ===== ビジネス・マネジメント系 =====
  {
    id: '28',
    name: '営業',
    category: 'ビジネス・マネジメント',
    description: '顧客との関係構築や目標達成が重要な職業。スポーツで培った目標達成力やコミュニケーション力が活かせます。',
    riasecProfile: { R: 10, I: 5, A: 10, S: 25, E: 40, C: 10 },
    requiredValues: ['経済的報酬', '達成感', '人間関係'],
    requiredSkills: ['コミュニケーション力', '交渉力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '営業 → 営業リーダー → 営業マネージャー → 事業責任者',
    averageSalary: '400-800万円',
    requiredEducation: '高卒以上',
    growthPotential: 'high',
  },
  {
    id: '29',
    name: '不動産営業',
    category: 'ビジネス・マネジメント',
    description: '不動産の売買・賃貸の仲介業務。高い交渉力と提案力、メンタルタフネスが求められます。',
    riasecProfile: { R: 10, I: 5, A: 10, S: 25, E: 40, C: 10 },
    requiredValues: ['経済的報酬', '達成感', '独立性'],
    requiredSkills: ['交渉力', 'コミュニケーション力', 'プレゼンテーション力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '営業 → 主任 → 店長 → 支店長',
    averageSalary: '400-1000万円',
    requiredEducation: '高卒以上、宅建資格推奨',
    growthPotential: 'high',
  },
  {
    id: '30',
    name: '人事・採用',
    category: 'ビジネス・マネジメント',
    description: '企業の採用活動や人材育成を担当。コミュニケーション力と人を見る目が重要です。',
    riasecProfile: { R: 5, I: 10, A: 10, S: 35, E: 20, C: 20 },
    requiredValues: ['人間関係', '自己成長', '社会貢献'],
    requiredSkills: ['コミュニケーション力', '傾聴力', '分析力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '人事担当 → 採用チームリーダー → 人事マネージャー → 人事部長',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '31',
    name: 'プロジェクトマネージャー',
    category: 'ビジネス・マネジメント',
    description: 'プロジェクト全体を管理し、チームを率いて目標達成を目指す。リーダーシップと計画力が重要です。',
    riasecProfile: { R: 5, I: 20, A: 10, S: 20, E: 25, C: 20 },
    requiredValues: ['達成感', '経済的報酬', '自己成長'],
    requiredSkills: ['計画力', 'コミュニケーション力', '問題発見力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: 'メンバー → リーダー → プロジェクトマネージャー → 部門責任者',
    averageSalary: '500-1000万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '32',
    name: '起業・経営',
    category: 'ビジネス・マネジメント',
    description: '自ら事業を立ち上げ経営する仕事。アスリートの挑戦精神と目標達成力が大いに活きます。',
    riasecProfile: { R: 10, I: 10, A: 15, S: 15, E: 40, C: 10 },
    requiredValues: ['独立性', '達成感', '経済的報酬'],
    requiredSkills: ['実行力', '交渉力', '計画力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: '起業 → 事業拡大 → 多角経営',
    averageSalary: '0-5000万円以上',
    requiredEducation: '不問、経営知識推奨',
    growthPotential: 'high',
  },
  {
    id: '33',
    name: '組織開発・人材育成',
    category: 'ビジネス・マネジメント',
    description: '組織の成長と人材の育成を推進する仕事。チームビルディングの経験が活かせます。',
    riasecProfile: { R: 5, I: 20, A: 15, S: 35, E: 15, C: 10 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['コミュニケーション力', '傾聴力', '計画力', '分析力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '担当者 → シニア担当 → マネージャー → 部長',
    averageSalary: '450-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  // ===== インフラ・物流系 =====
  {
    id: '34',
    name: '海上保安官',
    category: '建設・インフラ・物流',
    description: '海上の安全確保や法令の執行、海難救助を行う仕事。体力と使命感が求められます。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['実行力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '海上保安官 → 主任 → 管区本部 → 幹部',
    averageSalary: '400-700万円',
    requiredEducation: '高卒以上、海上保安学校・海上保安大学校卒',
    growthPotential: 'medium',
  },
  {
    id: '35',
    name: '皇宮護衛官',
    category: '建設・インフラ・物流',
    description: '皇居や御所の警備、皇族の護衛を行う仕事。高い体力と規律、礼儀が求められます。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['安定性', '社会貢献', '達成感'],
    requiredSkills: ['実行力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '皇宮護衛官 → 主任 → 係長 → 管理職',
    averageSalary: '400-700万円',
    requiredEducation: '高卒以上、皇宮護衛官採用試験合格',
    growthPotential: 'medium',
  },
  {
    id: '36',
    name: '物流・製造管理',
    category: '建設・インフラ・物流',
    description: '物流センターや製造現場の管理を行う仕事。計画性と実行力が求められます。',
    riasecProfile: { R: 35, I: 10, A: 5, S: 15, E: 15, C: 20 },
    requiredValues: ['安定性', '達成感', 'ワークライフバランス'],
    requiredSkills: ['計画力', '実行力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 3, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'スタッフ → 班長 → 係長 → 工場長・センター長',
    averageSalary: '350-600万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  // ===== 接客・販売系 =====
  {
    id: '37',
    name: '接客・販売',
    category: 'サービス・ライフスタイル',
    description: '商品販売や接客業務全般。人と関わることが好きで、体力のある方に向いています。',
    riasecProfile: { R: 20, I: 5, A: 10, S: 30, E: 25, C: 10 },
    requiredValues: ['人間関係', '達成感', 'ワークライフバランス'],
    requiredSkills: ['コミュニケーション力', '実行力', '傾聴力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '販売スタッフ → 主任 → 店長 → エリアマネージャー',
    averageSalary: '280-450万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  {
    id: '38',
    name: 'スポーツ用品販売',
    category: 'サービス・ライフスタイル',
    description: 'スポーツ用品店での販売・接客。自身のスポーツ経験を活かして商品提案ができます。',
    riasecProfile: { R: 20, I: 5, A: 10, S: 30, E: 25, C: 10 },
    requiredValues: ['人間関係', '経済的報酬', '達成感'],
    requiredSkills: ['コミュニケーション力', '交渉力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '販売スタッフ → 主任 → 店長 → エリアマネージャー',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  {
    id: '39',
    name: 'ホテル・飲食',
    category: 'サービス・ライフスタイル',
    description: 'ホテルや飲食店での接客・サービス業務。おもてなしの心とチームワークが求められます。',
    riasecProfile: { R: 20, I: 5, A: 15, S: 35, E: 15, C: 10 },
    requiredValues: ['人間関係', '社会貢献', 'ワークライフバランス'],
    requiredSkills: ['コミュニケーション力', '傾聴力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 3, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'スタッフ → 主任 → マネージャー → 支配人',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  {
    id: '40',
    name: 'カスタマーサポート',
    category: 'サービス・ライフスタイル',
    description: '顧客からの問い合わせ対応やサポート業務。コミュニケーション力と問題解決力が重要です。',
    riasecProfile: { R: 5, I: 10, A: 5, S: 40, E: 10, C: 30 },
    requiredValues: ['人間関係', 'ワークライフバランス', '安定性'],
    requiredSkills: ['コミュニケーション力', '傾聴力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'サポートスタッフ → リーダー → マネージャー → 部門責任者',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  // ===== 事務系 =====
  {
    id: '41',
    name: '事務',
    category: 'ビジネス・マネジメント',
    description: '書類作成、データ入力、電話対応など企業の基盤を支える仕事。正確性と計画性が求められます。',
    riasecProfile: { R: 5, I: 10, A: 5, S: 15, E: 5, C: 60 },
    requiredValues: ['安定性', 'ワークライフバランス', '人間関係'],
    requiredSkills: ['計画力', '実行力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: '一般事務 → 主任 → 係長 → 課長',
    averageSalary: '300-450万円',
    requiredEducation: '高卒以上、PCスキル',
    growthPotential: 'low',
  },
  {
    id: '42',
    name: '経理',
    category: 'ビジネス・マネジメント',
    description: '企業のお金の流れを管理する仕事。正確性と責任感、数字に対する強さが重要です。',
    riasecProfile: { R: 5, I: 20, A: 5, S: 10, E: 5, C: 55 },
    requiredValues: ['安定性', '経済的報酬', '達成感'],
    requiredSkills: ['分析力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: '経理担当 → 主任 → 経理課長 → 経理部長',
    averageSalary: '350-600万円',
    requiredEducation: '高卒以上、簿記資格推奨',
    growthPotential: 'medium',
  },
  {
    id: '43',
    name: '総務',
    category: 'ビジネス・マネジメント',
    description: '企業の管理部門で幅広い業務を担当。社内調整力とマルチタスク能力が求められます。',
    riasecProfile: { R: 5, I: 15, A: 5, S: 20, E: 5, C: 50 },
    requiredValues: ['安定性', 'ワークライフバランス', '人間関係'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '総務担当 → 主任 → 総務課長 → 総務部長',
    averageSalary: '350-550万円',
    requiredEducation: '大卒以上',
    growthPotential: 'low',
  },
  // ===== IT・テクノロジー系 =====
  {
    id: '44',
    name: 'エンジニア',
    category: 'IT・テクノロジー',
    description: 'システム開発やプログラミングを行う専門職。論理的思考力と問題解決力が求められます。',
    riasecProfile: { R: 15, I: 45, A: 10, S: 5, E: 5, C: 20 },
    requiredValues: ['自己成長', '経済的報酬', '独立性'],
    requiredSkills: ['分析力', '問題発見力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'エンジニア → シニアエンジニア → テックリード → CTO',
    averageSalary: '450-1000万円',
    requiredEducation: '大卒以上、プログラミングスキル',
    growthPotential: 'high',
  },
  {
    id: '45',
    name: 'スポーツテック開発',
    category: 'IT・テクノロジー',
    description: 'スポーツ分野のテクノロジー開発を行う仕事。IT技術とスポーツ知識の両方が必要です。',
    riasecProfile: { R: 20, I: 40, A: 10, S: 10, E: 5, C: 15 },
    requiredValues: ['自己成長', '達成感', '独立性'],
    requiredSkills: ['分析力', '問題発見力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'エンジニア → シニアエンジニア → プロダクトリード → CTO',
    averageSalary: '450-900万円',
    requiredEducation: '大卒以上、プログラミング・スポーツ科学知識',
    growthPotential: 'high',
  },
  {
    id: '46',
    name: 'データアナリスト',
    category: 'IT・テクノロジー',
    description: 'データ分析によりビジネス課題を解決する仕事。論理的思考と分析力が求められます。',
    riasecProfile: { R: 10, I: 55, A: 5, S: 5, E: 5, C: 20 },
    requiredValues: ['自己成長', '経済的報酬', '独立性'],
    requiredSkills: ['分析力', '問題発見力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'アナリスト → シニアアナリスト → データサイエンティスト',
    averageSalary: '450-900万円',
    requiredEducation: '大卒以上、統計学・プログラミング知識',
    growthPotential: 'high',
  },
  {
    id: '47',
    name: '動作解析',
    category: 'IT・テクノロジー',
    description: 'スポーツにおける動作をテクノロジーで解析し、パフォーマンス向上に貢献する仕事。',
    riasecProfile: { R: 30, I: 40, A: 5, S: 15, E: 0, C: 10 },
    requiredValues: ['自己成長', '達成感', '社会貢献'],
    requiredSkills: ['分析力', '問題発見力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: true,
    careerPath: 'アナリスト → シニアアナリスト → パフォーマンス分析責任者',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上、スポーツ科学・バイオメカニクス知識',
    growthPotential: 'high',
  },
  // ===== デザイン・クリエイティブ系 =====
  {
    id: '48',
    name: 'Webデザイン',
    category: 'メディア・クリエイティブ',
    description: 'Webサイトのデザインを行う仕事。創造性と技術力の両方が必要です。',
    riasecProfile: { R: 10, I: 20, A: 45, S: 10, E: 5, C: 10 },
    requiredValues: ['自己成長', '達成感', '独立性'],
    requiredSkills: ['分析力', '計画力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'デザイナー → シニアデザイナー → アートディレクター',
    averageSalary: '350-700万円',
    requiredEducation: '専門学校卒以上、デザインスキル',
    growthPotential: 'high',
  },
  {
    id: '49',
    name: 'グラフィックデザイン',
    category: 'メディア・クリエイティブ',
    description: 'ポスター、ロゴ、パッケージなどのビジュアルデザインを行う専門職。',
    riasecProfile: { R: 10, I: 10, A: 60, S: 5, E: 10, C: 5 },
    requiredValues: ['達成感', '自己成長', '独立性'],
    requiredSkills: ['計画力', '分析力', 'プレゼンテーション力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'デザイナー → シニアデザイナー → クリエイティブディレクター',
    averageSalary: '350-700万円',
    requiredEducation: '専門学校卒以上',
    growthPotential: 'medium',
  },
  {
    id: '50',
    name: 'UI/UXデザイン',
    category: 'メディア・クリエイティブ',
    description: 'ユーザー体験を設計するデザイン職。分析力と創造性の両方が求められます。',
    riasecProfile: { R: 10, I: 20, A: 45, S: 10, E: 5, C: 10 },
    requiredValues: ['自己成長', '達成感', '独立性'],
    requiredSkills: ['分析力', '問題発見力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'UIデザイナー → シニアUXデザイナー → デザインリード',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上、デザイン・IT知識',
    growthPotential: 'high',
  },
  {
    id: '51',
    name: 'カメラ・編集',
    category: 'メディア・クリエイティブ',
    description: '写真撮影や映像編集を行うクリエイティブ職。技術力と芸術的センスが必要です。',
    riasecProfile: { R: 20, I: 15, A: 50, S: 10, E: 5, C: 0 },
    requiredValues: ['達成感', '独立性', '自己成長'],
    requiredSkills: ['実行力', '計画力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 2, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'アシスタント → カメラマン・エディター → フリーランス → スタジオ経営',
    averageSalary: '300-700万円',
    requiredEducation: '専門学校卒以上、実績重視',
    growthPotential: 'medium',
  },
  // ===== 美容・ライフスタイル系 =====
  {
    id: '52',
    name: '美容',
    category: 'サービス・ライフスタイル',
    description: 'ヘアカット、カラー、パーマなど美容技術を提供。手に職をつけられる仕事です。',
    riasecProfile: { R: 35, I: 5, A: 35, S: 15, E: 10, C: 0 },
    requiredValues: ['自己成長', '達成感', '人間関係'],
    requiredSkills: ['コミュニケーション力', '実行力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'アシスタント → スタイリスト → 店長 → 独立開業',
    averageSalary: '300-600万円',
    requiredEducation: '美容師免許必須',
    growthPotential: 'medium',
  },
  {
    id: '53',
    name: 'エステ',
    category: 'サービス・ライフスタイル',
    description: 'フェイシャルやボディケアなどのエステティック施術を提供する専門職。',
    riasecProfile: { R: 25, I: 5, A: 40, S: 25, E: 5, C: 0 },
    requiredValues: ['自己成長', '人間関係', '達成感'],
    requiredSkills: ['コミュニケーション力', '実行力', '傾聴力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'エステティシャン → チーフ → 店長 → 独立開業',
    averageSalary: '280-500万円',
    requiredEducation: '高卒以上、各種資格推奨',
    growthPotential: 'medium',
  },
  {
    id: '54',
    name: 'ネイル',
    category: 'サービス・ライフスタイル',
    description: 'ネイルアートやケアを提供する専門職。繊細な技術とセンスが求められます。',
    riasecProfile: { R: 25, I: 5, A: 40, S: 25, E: 5, C: 0 },
    requiredValues: ['自己成長', '達成感', '人間関係'],
    requiredSkills: ['実行力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 2, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'ネイリスト → チーフネイリスト → 店長 → 独立開業',
    averageSalary: '250-450万円',
    requiredEducation: '高卒以上、ネイリスト検定推奨',
    growthPotential: 'medium',
  },
  {
    id: '55',
    name: '料理',
    category: 'サービス・ライフスタイル',
    description: '調理技術を活かして料理を提供する仕事。体力と忍耐力、創造性が必要です。',
    riasecProfile: { R: 50, I: 10, A: 25, S: 10, E: 5, C: 0 },
    requiredValues: ['自己成長', '達成感', '独立性'],
    requiredSkills: ['実行力', '計画力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '見習い → 調理師 → 料理長 → 独立開業',
    averageSalary: '300-600万円',
    requiredEducation: '高卒以上、調理師免許推奨',
    growthPotential: 'medium',
  },
  // ===== 語学系 =====
  {
    id: '56',
    name: '通訳',
    category: 'サービス・ライフスタイル',
    description: '言語の橋渡しを行う専門職。高い語学力と瞬発力が求められます。',
    riasecProfile: { R: 5, I: 35, A: 15, S: 35, E: 5, C: 5 },
    requiredValues: ['自己成長', '経済的報酬', '達成感'],
    requiredSkills: ['コミュニケーション力', '分析力', '実行力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: '通訳者 → 会議通訳 → フリーランス',
    averageSalary: '400-1000万円',
    requiredEducation: '大卒以上、高度な語学力',
    growthPotential: 'high',
  },
  {
    id: '57',
    name: '翻訳',
    category: 'サービス・ライフスタイル',
    description: '文書の翻訳を行う専門職。正確性と語学力、専門知識が重要です。',
    riasecProfile: { R: 5, I: 40, A: 20, S: 10, E: 5, C: 20 },
    requiredValues: ['独立性', '自己成長', 'ワークライフバランス'],
    requiredSkills: ['分析力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 2, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 1 },
    athleteFriendly: false,
    careerPath: '翻訳者 → 専門翻訳者 → フリーランス',
    averageSalary: '300-800万円',
    requiredEducation: '大卒以上、高度な語学力',
    growthPotential: 'medium',
  },
  // ===== 公務員系 =====
  {
    id: '58',
    name: '国家公務員',
    category: '公務員・行政・公安',
    description: '国の行政機関で政策立案や行政事務を行う仕事。安定性と社会貢献を両立できます。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['安定性', '社会貢献', 'ワークライフバランス'],
    requiredSkills: ['分析力', '計画力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '係員 → 主任 → 係長 → 課長補佐 → 課長',
    averageSalary: '450-750万円',
    requiredEducation: '大卒以上、国家公務員試験合格',
    growthPotential: 'medium',
  },
  {
    id: '59',
    name: '地方公務員',
    category: '公務員・行政・公安',
    description: '地方自治体で住民サービスや行政事務を行う仕事。地域に密着した安定したキャリアです。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['安定性', '社会貢献', 'ワークライフバランス'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '主事 → 主任 → 係長 → 課長 → 部長',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上、地方公務員試験合格',
    growthPotential: 'medium',
  },
  // ===== 公安職 =====
  {
    id: '60',
    name: '警察官',
    category: '公務員・行政・公安',
    description: '犯罪捜査や交通取締り、地域のパトロールなど治安維持を担う仕事。体力と正義感が不可欠です。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['実行力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '巡査 → 巡査部長 → 警部補 → 警部 → 警視',
    averageSalary: '450-750万円',
    requiredEducation: '高卒以上、警察官採用試験合格',
    growthPotential: 'medium',
  },
  {
    id: '61',
    name: '消防士',
    category: '公務員・行政・公安',
    description: '火災消火や救急・救助活動を行う仕事。高い体力と冷静な判断力、チームワークが求められます。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['実行力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '消防士 → 消防士長 → 消防司令補 → 消防司令',
    averageSalary: '450-750万円',
    requiredEducation: '高卒以上、消防官採用試験合格',
    growthPotential: 'medium',
  },
  {
    id: '62',
    name: '自衛官',
    category: '公務員・行政・公安',
    description: '国防任務に加え、災害派遣や国際貢献活動にも従事。厳しい訓練を通じて心身を鍛えられます。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['実行力', '計画力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '二等陸士 → 陸士長 → 三等陸曹 → 幹部自衛官',
    averageSalary: '400-700万円',
    requiredEducation: '高卒以上、自衛官採用試験合格',
    growthPotential: 'medium',
  },
  {
    id: '63',
    name: '刑務官',
    category: '公務員・行政・公安',
    description: '刑事施設で受刑者の管理や矯正教育に携わる仕事。体力と精神的な強さが求められます。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['安定性', '社会貢献', '達成感'],
    requiredSkills: ['実行力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '刑務官 → 主任 → 統括 → 首席',
    averageSalary: '400-650万円',
    requiredEducation: '高卒以上、刑務官採用試験合格',
    growthPotential: 'low',
  },
  {
    id: '64',
    name: '入国警備官',
    category: '公務員・行政・公安',
    description: '出入国管理業務や不法滞在者の摘発を行う仕事。体力と語学力が活かせます。',
    riasecProfile: { R: 45, I: 10, A: 5, S: 25, E: 10, C: 5 },
    requiredValues: ['安定性', '社会貢献', '達成感'],
    requiredSkills: ['実行力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '入国警備官 → 主任警備官 → 統括警備官',
    averageSalary: '400-650万円',
    requiredEducation: '高卒以上、入国警備官採用試験合格',
    growthPotential: 'low',
  },
  // ===== 教育行政系 =====
  {
    id: '65',
    name: '学校職員（事務）',
    category: '公務員・行政・公安',
    description: '学校の事務業務全般を担当。教育現場を裏方から支える安定した仕事です。',
    riasecProfile: { R: 5, I: 10, A: 5, S: 15, E: 5, C: 60 },
    requiredValues: ['安定性', 'ワークライフバランス', '社会貢献'],
    requiredSkills: ['計画力', '実行力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: '事務職員 → 主任 → 事務長',
    averageSalary: '350-550万円',
    requiredEducation: '大卒以上、採用試験合格',
    growthPotential: 'low',
  },
  {
    id: '66',
    name: '大学職員',
    category: '公務員・行政・公安',
    description: '大学の運営や学生支援に携わる仕事。教育への理解と事務能力が求められます。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['安定性', '社会貢献', 'ワークライフバランス'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '職員 → 主任 → 課長 → 部長',
    averageSalary: '400-650万円',
    requiredEducation: '大卒以上',
    growthPotential: 'low',
  },
  {
    id: '67',
    name: '教育委員会職員',
    category: '公務員・行政・公安',
    description: '教育行政の企画・運営に携わる仕事。教育政策と行政実務の両方の知識が必要です。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['社会貢献', '安定性', 'ワークライフバランス'],
    requiredSkills: ['計画力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '主事 → 主任 → 係長 → 課長',
    averageSalary: '400-650万円',
    requiredEducation: '大卒以上、公務員試験合格',
    growthPotential: 'low',
  },
  // ===== 行政・政策系 =====
  {
    id: '68',
    name: 'スポーツ庁・行政職員',
    category: '公務員・行政・公安',
    description: 'スポーツ庁等でスポーツ政策の企画・立案に携わる仕事。スポーツと行政の両方の知識が必要です。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['計画力', '分析力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '係員 → 主任 → 係長 → 課長補佐 → 課長',
    averageSalary: '450-750万円',
    requiredEducation: '大卒以上、国家公務員試験合格',
    growthPotential: 'medium',
  },
  {
    id: '69',
    name: '地域振興担当',
    category: '公務員・行政・公安',
    description: 'スポーツや文化を活用した地域活性化に取り組む仕事。企画力と地域への愛着が重要です。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['社会貢献', '達成感', '人間関係'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '担当者 → 主任 → 係長 → 課長',
    averageSalary: '400-650万円',
    requiredEducation: '大卒以上、公務員試験合格',
    growthPotential: 'medium',
  },
  {
    id: '70',
    name: '健康政策担当',
    category: '公務員・行政・公安',
    description: '国民の健康増進政策の企画・推進に携わる仕事。公衆衛生とスポーツの知識が活かせます。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 25, E: 15, C: 25 },
    requiredValues: ['社会貢献', '安定性', '達成感'],
    requiredSkills: ['分析力', '計画力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '担当者 → 主任 → 係長 → 課長',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上、公務員試験合格',
    growthPotential: 'medium',
  },
  // ===== 企業総合職系 =====
  {
    id: '71',
    name: '企業の総合職',
    category: 'ビジネス・マネジメント',
    description: '企業の幹部候補として様々な部署を経験しながらキャリアを積む仕事。バランスの良い能力が求められます。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 20, E: 30, C: 15 },
    requiredValues: ['経済的報酬', '自己成長', '達成感'],
    requiredSkills: ['コミュニケーション力', '実行力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '総合職 → 主任 → 課長 → 部長 → 役員',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '72',
    name: '企画職',
    category: 'ビジネス・マネジメント',
    description: '新しい商品やサービス、事業の企画を行う仕事。創造性と論理的思考力が求められます。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 20, E: 30, C: 15 },
    requiredValues: ['達成感', '自己成長', '経済的報酬'],
    requiredSkills: ['分析力', 'プレゼンテーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: false,
    careerPath: '企画担当 → 企画リーダー → 企画マネージャー → 事業責任者',
    averageSalary: '450-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '73',
    name: '経営企画',
    category: 'ビジネス・マネジメント',
    description: '企業の中長期戦略や経営計画の策定を行う仕事。高い分析力と経営視点が求められます。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 20, E: 30, C: 15 },
    requiredValues: ['達成感', '経済的報酬', '自己成長'],
    requiredSkills: ['分析力', '計画力', 'プレゼンテーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: false,
    careerPath: '経営企画担当 → マネージャー → 部長 → 役員',
    averageSalary: '500-1000万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '74',
    name: '事業開発',
    category: 'ビジネス・マネジメント',
    description: '新規事業の立ち上げやパートナーシップ構築を行う仕事。起業家精神と行動力が必要です。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 20, E: 30, C: 15 },
    requiredValues: ['達成感', '経済的報酬', '独立性'],
    requiredSkills: ['交渉力', '実行力', '計画力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: '事業開発担当 → マネージャー → 事業部長 → 役員',
    averageSalary: '500-1200万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  // ===== コンサルティング・人材系 =====
  {
    id: '75',
    name: 'コンサルタント',
    category: 'ビジネス・マネジメント',
    description: '企業の課題解決を支援する専門職。論理的思考力とプレゼンテーション力が求められます。',
    riasecProfile: { R: 5, I: 20, A: 10, S: 20, E: 35, C: 10 },
    requiredValues: ['経済的報酬', '達成感', '自己成長'],
    requiredSkills: ['分析力', 'プレゼンテーション力', '問題発見力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: false,
    careerPath: 'アナリスト → コンサルタント → マネージャー → パートナー',
    averageSalary: '500-1500万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '76',
    name: 'キャリアコンサルタント',
    category: 'ビジネス・マネジメント',
    description: '個人のキャリア形成を支援する専門職。アスリートのセカンドキャリア支援にも関われます。',
    riasecProfile: { R: 5, I: 15, A: 10, S: 40, E: 20, C: 10 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['傾聴力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'キャリアコンサルタント → シニアコンサルタント → 独立',
    averageSalary: '350-700万円',
    requiredEducation: '大卒以上、キャリアコンサルタント国家資格',
    growthPotential: 'medium',
  },
  {
    id: '77',
    name: '人材コーディネーター',
    category: 'ビジネス・マネジメント',
    description: '求職者と企業のマッチングを行う仕事。コミュニケーション力と営業力が求められます。',
    riasecProfile: { R: 5, I: 15, A: 10, S: 40, E: 20, C: 10 },
    requiredValues: ['人間関係', '達成感', '経済的報酬'],
    requiredSkills: ['コミュニケーション力', '交渉力', '傾聴力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'コーディネーター → リーダー → マネージャー → 事業責任者',
    averageSalary: '350-650万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  // ===== 金融系 =====
  {
    id: '78',
    name: '金融営業',
    category: '金融・不動産',
    description: '金融商品の提案や資産運用のアドバイスを行う仕事。数字への強さと信頼構築力が重要です。',
    riasecProfile: { R: 10, I: 5, A: 10, S: 25, E: 40, C: 10 },
    requiredValues: ['経済的報酬', '達成感', '自己成長'],
    requiredSkills: ['交渉力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '営業 → リーダー → 支店長 → エリアマネージャー',
    averageSalary: '450-1000万円',
    requiredEducation: '大卒以上、FP資格推奨',
    growthPotential: 'high',
  },
  {
    id: '79',
    name: '銀行員',
    category: '金融・不動産',
    description: '銀行での融資業務や窓口業務を行う仕事。信頼性と正確性が求められます。',
    riasecProfile: { R: 5, I: 15, A: 5, S: 20, E: 25, C: 30 },
    requiredValues: ['安定性', '経済的報酬', '社会貢献'],
    requiredSkills: ['コミュニケーション力', '分析力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '一般職 → 主任 → 課長 → 支店長',
    averageSalary: '450-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '80',
    name: '保険営業',
    category: '金融・不動産',
    description: '保険商品の提案・販売を行う仕事。メンタルタフネスと目標達成力が求められます。',
    riasecProfile: { R: 10, I: 5, A: 10, S: 25, E: 40, C: 10 },
    requiredValues: ['経済的報酬', '達成感', '人間関係'],
    requiredSkills: ['コミュニケーション力', '交渉力', 'プレゼンテーション力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '営業 → チームリーダー → 所長 → 支社長',
    averageSalary: '300-1200万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  // ===== 不動産・施設管理系 =====
  {
    id: '81',
    name: '不動産管理',
    category: '金融・不動産',
    description: '不動産物件の管理・運営を行う仕事。安定的な業務と対人スキルが求められます。',
    riasecProfile: { R: 25, I: 10, A: 5, S: 20, E: 15, C: 25 },
    requiredValues: ['安定性', '経済的報酬', 'ワークライフバランス'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '管理担当 → 主任 → マネージャー → 部長',
    averageSalary: '350-600万円',
    requiredEducation: '高卒以上、管理業務主任者推奨',
    growthPotential: 'medium',
  },
  {
    id: '82',
    name: 'マンション管理',
    category: '金融・不動産',
    description: 'マンションの管理組合運営サポートや建物維持管理を行う仕事。',
    riasecProfile: { R: 25, I: 10, A: 5, S: 20, E: 15, C: 25 },
    requiredValues: ['安定性', 'ワークライフバランス', '人間関係'],
    requiredSkills: ['コミュニケーション力', '計画力', '問題発見力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'フロント担当 → 主任 → マネージャー → 支店長',
    averageSalary: '350-550万円',
    requiredEducation: '高卒以上、管理業務主任者推奨',
    growthPotential: 'low',
  },
  {
    id: '83',
    name: '施設管理',
    category: '金融・不動産',
    description: 'ビルや施設の設備管理・メンテナンスを行う仕事。体力と技術知識が求められます。',
    riasecProfile: { R: 25, I: 10, A: 5, S: 20, E: 15, C: 25 },
    requiredValues: ['安定性', 'ワークライフバランス', '達成感'],
    requiredSkills: ['実行力', '計画力', '問題発見力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '管理スタッフ → 主任 → 施設管理責任者',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上、ビル管理士推奨',
    growthPotential: 'low',
  },
  // ===== 建設系 =====
  {
    id: '84',
    name: '施工管理',
    category: '建設・インフラ・物流',
    description: '建設現場の工程・品質・安全管理を行う仕事。体力とリーダーシップが求められます。',
    riasecProfile: { R: 40, I: 15, A: 5, S: 15, E: 15, C: 10 },
    requiredValues: ['達成感', '安定性', '経済的報酬'],
    requiredSkills: ['計画力', '実行力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 5, growthMindsetLevel: 3, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: '施工管理 → 主任 → 所長 → 部長',
    averageSalary: '400-750万円',
    requiredEducation: '高卒以上、施工管理技士推奨',
    growthPotential: 'medium',
  },
  {
    id: '85',
    name: '建設管理',
    category: '建設・インフラ・物流',
    description: '建設プロジェクト全体のマネジメントを行う仕事。計画力と調整力が不可欠です。',
    riasecProfile: { R: 40, I: 15, A: 5, S: 15, E: 15, C: 10 },
    requiredValues: ['達成感', '安定性', '経済的報酬'],
    requiredSkills: ['計画力', 'コミュニケーション力', '実行力', '問題発見力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: '建設管理担当 → マネージャー → 統括所長 → 部長',
    averageSalary: '450-800万円',
    requiredEducation: '大卒以上、建築士・施工管理技士推奨',
    growthPotential: 'medium',
  },
  // ===== フィットネス・ウェルネス系 =====
  {
    id: '86',
    name: 'インストラクター（スポーツ以外）',
    category: 'スポーツ指導・トレーニング',
    description: 'エアロビクスやダンスなどスポーツ以外のフィットネス指導を行う仕事。体力と指導力が活かせます。',
    riasecProfile: { R: 25, I: 5, A: 15, S: 35, E: 10, C: 10 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['コミュニケーション力', '実行力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'インストラクター → チーフインストラクター → プログラムディレクター',
    averageSalary: '280-450万円',
    requiredEducation: '高卒以上、関連資格推奨',
    growthPotential: 'medium',
  },
  {
    id: '87',
    name: 'フィットネスジム運営',
    category: 'スポーツ指導・トレーニング',
    description: 'フィットネスジムの経営・運営を行う仕事。経営感覚とフィットネス知識の両方が必要です。',
    riasecProfile: { R: 20, I: 10, A: 10, S: 20, E: 25, C: 15 },
    requiredValues: ['達成感', '経済的報酬', '独立性'],
    requiredSkills: ['計画力', '実行力', 'コミュニケーション力', '交渉力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 5 },
    athleteFriendly: true,
    careerPath: 'スタッフ → マネージャー → オーナー → 多店舗経営',
    averageSalary: '350-800万円',
    requiredEducation: '高卒以上、経営知識推奨',
    growthPotential: 'medium',
  },
  {
    id: '88',
    name: 'ヨガ・ピラティス指導',
    category: 'スポーツ指導・トレーニング',
    description: 'ヨガやピラティスの指導を行う仕事。身体の知識と指導力、コミュニケーション力が必要です。',
    riasecProfile: { R: 30, I: 10, A: 15, S: 30, E: 10, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '独立性'],
    requiredSkills: ['コミュニケーション力', '実行力', '傾聴力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'インストラクター → シニアインストラクター → スタジオ経営',
    averageSalary: '250-500万円',
    requiredEducation: '高卒以上、RYT200等の資格推奨',
    growthPotential: 'medium',
  },
  // ===== 警備・危機管理系 =====
  {
    id: '89',
    name: '警備',
    category: '建設・インフラ・物流',
    description: '施設やイベントの警備業務を行う仕事。体力と注意力、責任感が求められます。',
    riasecProfile: { R: 40, I: 10, A: 5, S: 15, E: 10, C: 20 },
    requiredValues: ['安定性', '社会貢献', 'ワークライフバランス'],
    requiredSkills: ['実行力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 4, growthMindsetLevel: 2, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '警備員 → 隊長 → 管理者 → 警備会社幹部',
    averageSalary: '280-450万円',
    requiredEducation: '高卒以上',
    growthPotential: 'low',
  },
  {
    id: '90',
    name: '危機管理担当',
    category: '建設・インフラ・物流',
    description: '企業や組織のリスク管理・危機対応を担当する仕事。冷静な判断力と計画力が不可欠です。',
    riasecProfile: { R: 40, I: 10, A: 5, S: 15, E: 10, C: 20 },
    requiredValues: ['安定性', '達成感', '社会貢献'],
    requiredSkills: ['分析力', '計画力', '問題発見力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 5, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '担当者 → マネージャー → 危機管理部長 → CSO',
    averageSalary: '450-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  // ===== 観光系 =====
  {
    id: '91',
    name: 'ツアーガイド',
    category: 'サービス・ライフスタイル',
    description: '観光客を案内し、旅行体験を提供する仕事。コミュニケーション力と体力が活かせます。',
    riasecProfile: { R: 20, I: 5, A: 15, S: 35, E: 15, C: 10 },
    requiredValues: ['人間関係', '社会貢献', '自己成長'],
    requiredSkills: ['コミュニケーション力', 'プレゼンテーション力', '実行力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 3, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'ガイド → シニアガイド → ツアーマネージャー',
    averageSalary: '280-450万円',
    requiredEducation: '高卒以上、語学力があれば尚可',
    growthPotential: 'medium',
  },
  {
    id: '92',
    name: '観光業スタッフ',
    category: 'サービス・ライフスタイル',
    description: '観光施設や旅行代理店での企画・運営業務を行う仕事。ホスピタリティとチームワークが重要です。',
    riasecProfile: { R: 20, I: 5, A: 15, S: 35, E: 15, C: 10 },
    requiredValues: ['人間関係', '社会貢献', 'ワークライフバランス'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 3, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'スタッフ → リーダー → マネージャー → 支店長',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  // ===== 運輸系 =====
  {
    id: '93',
    name: '輸送・運輸職',
    category: '建設・インフラ・物流',
    description: '物流や輸送業務の管理・実務を行う仕事。体力と計画性が求められます。',
    riasecProfile: { R: 45, I: 5, A: 5, S: 15, E: 10, C: 20 },
    requiredValues: ['安定性', 'ワークライフバランス', '達成感'],
    requiredSkills: ['実行力', '計画力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 3, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'スタッフ → リーダー → マネージャー → センター長',
    averageSalary: '350-550万円',
    requiredEducation: '高卒以上',
    growthPotential: 'medium',
  },
  {
    id: '94',
    name: 'ドライバー',
    category: '建設・インフラ・物流',
    description: 'トラックやバスなどの運転業務を行う仕事。体力と集中力、安全意識が重要です。',
    riasecProfile: { R: 45, I: 5, A: 5, S: 15, E: 10, C: 20 },
    requiredValues: ['安定性', 'ワークライフバランス', '独立性'],
    requiredSkills: ['実行力', '計画力', '問題発見力'],
    basicAbilities: { teamworkLevel: 2, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 2, leadershipLevel: 2 },
    athleteFriendly: true,
    careerPath: 'ドライバー → 班長 → 配車係 → 運行管理者',
    averageSalary: '300-500万円',
    requiredEducation: '高卒以上、大型免許等',
    growthPotential: 'low',
  },
  // ===== 研究・学術系 =====
  {
    id: '95',
    name: '研究職（スポーツ科学）',
    category: '医療・健康・教育',
    description: 'スポーツ科学の研究を行い、アスリートのパフォーマンス向上に貢献する仕事。',
    riasecProfile: { R: 15, I: 50, A: 10, S: 10, E: 5, C: 10 },
    requiredValues: ['自己成長', '達成感', '社会貢献'],
    requiredSkills: ['分析力', '問題発見力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: true,
    careerPath: '研究助手 → 研究員 → 主任研究員 → 教授',
    averageSalary: '400-800万円',
    requiredEducation: '大学院修了（修士以上）',
    growthPotential: 'medium',
  },
  {
    id: '96',
    name: '大学研究員',
    category: '医療・健康・教育',
    description: '大学で学術研究と教育に携わる仕事。高い専門性と探究心が求められます。',
    riasecProfile: { R: 15, I: 50, A: 10, S: 10, E: 5, C: 10 },
    requiredValues: ['自己成長', '達成感', '独立性'],
    requiredSkills: ['分析力', '問題発見力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 2 },
    athleteFriendly: false,
    careerPath: 'ポスドク → 助教 → 准教授 → 教授',
    averageSalary: '400-900万円',
    requiredEducation: '博士号取得',
    growthPotential: 'medium',
  },
  // ===== 教育系 =====
  {
    id: '97',
    name: '講師（専門学校・大学）',
    category: '医療・健康・教育',
    description: '専門学校や大学で専門知識を教える仕事。実務経験と教育力の両方が求められます。',
    riasecProfile: { R: 5, I: 15, A: 20, S: 40, E: 15, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['プレゼンテーション力', 'コミュニケーション力', '計画力'],
    basicAbilities: { teamworkLevel: 3, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: '非常勤講師 → 常勤講師 → 准教授 → 教授',
    averageSalary: '350-800万円',
    requiredEducation: '大学院修了推奨、実務経験者優遇',
    growthPotential: 'medium',
  },
  // ===== 広報・PR系 =====
  {
    id: '98',
    name: '広報',
    category: 'メディア・クリエイティブ',
    description: '企業や組織の情報発信やメディア対応を担当する仕事。コミュニケーション力と企画力が重要です。',
    riasecProfile: { R: 5, I: 10, A: 25, S: 20, E: 30, C: 10 },
    requiredValues: ['達成感', '自己成長', '人間関係'],
    requiredSkills: ['コミュニケーション力', 'プレゼンテーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '広報担当 → 広報主任 → 広報マネージャー → 広報部長',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '99',
    name: 'PR',
    category: 'メディア・クリエイティブ',
    description: 'パブリックリレーションズの専門家として、ブランドイメージの構築と維持を行う仕事。',
    riasecProfile: { R: 5, I: 10, A: 25, S: 20, E: 30, C: 10 },
    requiredValues: ['達成感', '自己成長', '経済的報酬'],
    requiredSkills: ['コミュニケーション力', 'プレゼンテーション力', '分析力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: 'PRアシスタント → PRプランナー → PRマネージャー → PRディレクター',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '100',
    name: 'ブランド担当',
    category: 'メディア・クリエイティブ',
    description: '企業やプロダクトのブランド戦略を企画・推進する仕事。マーケティング知識と創造力が必要です。',
    riasecProfile: { R: 5, I: 10, A: 25, S: 20, E: 30, C: 10 },
    requiredValues: ['達成感', '自己成長', '経済的報酬'],
    requiredSkills: ['分析力', 'プレゼンテーション力', '計画力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 4 },
    athleteFriendly: false,
    careerPath: 'ブランド担当 → ブランドマネージャー → シニアマネージャー → CMO',
    averageSalary: '450-900万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  // ===== 商品開発系 =====
  {
    id: '101',
    name: '商品開発',
    category: 'ビジネス・マネジメント',
    description: '新商品の企画・開発を行う仕事。市場分析力と創造性が求められます。',
    riasecProfile: { R: 15, I: 25, A: 20, S: 10, E: 20, C: 10 },
    requiredValues: ['達成感', '自己成長', '経済的報酬'],
    requiredSkills: ['分析力', '計画力', '問題発見力', 'コミュニケーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: false,
    careerPath: '開発担当 → リーダー → 開発マネージャー → 事業責任者',
    averageSalary: '400-800万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '102',
    name: 'プロダクトマネージャー',
    category: 'ビジネス・マネジメント',
    description: '製品の企画から市場投入までを統括する仕事。ビジネス感覚と技術理解の両方が必要です。',
    riasecProfile: { R: 15, I: 25, A: 20, S: 10, E: 20, C: 10 },
    requiredValues: ['達成感', '自己成長', '経済的報酬'],
    requiredSkills: ['計画力', '分析力', 'コミュニケーション力', '問題発見力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 5, leadershipLevel: 5 },
    athleteFriendly: false,
    careerPath: 'PM → シニアPM → VPofProduct → CPO',
    averageSalary: '500-1200万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  // ===== コミュニティ・NPO系 =====
  {
    id: '103',
    name: 'コミュニティマネージャー',
    category: 'スポーツビジネス・社会貢献',
    description: 'オンライン・オフラインのコミュニティを運営・活性化する仕事。人をつなぐ力が重要です。',
    riasecProfile: { R: 5, I: 10, A: 15, S: 35, E: 25, C: 10 },
    requiredValues: ['人間関係', '社会貢献', '達成感'],
    requiredSkills: ['コミュニケーション力', '計画力', '傾聴力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'コミュニティスタッフ → マネージャー → ディレクター',
    averageSalary: '350-600万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '104',
    name: 'NPO職員',
    category: 'スポーツビジネス・社会貢献',
    description: '非営利組織で社会課題の解決に取り組む仕事。使命感とコミュニケーション力が重要です。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 35, E: 15, C: 15 },
    requiredValues: ['社会貢献', '人間関係', '自己成長'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'スタッフ → プロジェクトリーダー → マネージャー → 事務局長',
    averageSalary: '280-500万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  {
    id: '105',
    name: 'スポーツ支援団体職員',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツ振興やアスリート支援を行う団体で働く仕事。スポーツへの理解と情熱が活かせます。',
    riasecProfile: { R: 10, I: 15, A: 10, S: 35, E: 15, C: 15 },
    requiredValues: ['社会貢献', '人間関係', '達成感'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 5, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'スタッフ → 主任 → マネージャー → 事務局長',
    averageSalary: '300-550万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  // ===== スポンサーシップ・マネジメント系 =====
  {
    id: '106',
    name: 'スポンサーシップ担当',
    category: 'スポーツビジネス・社会貢献',
    description: 'スポーツチームやイベントのスポンサー獲得・管理を行う仕事。交渉力と企画力が重要です。',
    riasecProfile: { R: 10, I: 10, A: 10, S: 30, E: 30, C: 10 },
    requiredValues: ['達成感', '経済的報酬', '人間関係'],
    requiredSkills: ['交渉力', 'コミュニケーション力', 'プレゼンテーション力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 4 },
    athleteFriendly: true,
    careerPath: 'スポンサーシップ担当 → マネージャー → ディレクター → VP',
    averageSalary: '400-900万円',
    requiredEducation: '大卒以上',
    growthPotential: 'high',
  },
  {
    id: '107',
    name: 'アスリートマネジメントスタッフ',
    category: 'スポーツビジネス・社会貢献',
    description: 'アスリートの活動全般をサポートし、キャリア形成を支援する仕事。スポーツ業界の知識が不可欠です。',
    riasecProfile: { R: 10, I: 10, A: 10, S: 30, E: 30, C: 10 },
    requiredValues: ['人間関係', '達成感', '社会貢献'],
    requiredSkills: ['コミュニケーション力', '計画力', '交渉力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 5, mentalToughnessLevel: 4, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'マネジメントスタッフ → シニアスタッフ → マネージャー → 代表',
    averageSalary: '350-700万円',
    requiredEducation: '大卒以上',
    growthPotential: 'medium',
  },
  // ===== 健康経営系 =====
  {
    id: '108',
    name: '健康経営推進担当',
    category: '医療・健康・教育',
    description: '企業の健康経営施策の企画・推進を行う仕事。健康知識とビジネス感覚の両方が必要です。',
    riasecProfile: { R: 10, I: 20, A: 5, S: 30, E: 20, C: 15 },
    requiredValues: ['社会貢献', '自己成長', '達成感'],
    requiredSkills: ['計画力', 'コミュニケーション力', '分析力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 4, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: '担当者 → リーダー → マネージャー → 健康経営責任者',
    averageSalary: '400-700万円',
    requiredEducation: '大卒以上、健康経営アドバイザー推奨',
    growthPotential: 'high',
  },
  {
    id: '109',
    name: '企業内トレーナー',
    category: '医療・健康・教育',
    description: '企業に所属し、社員の健康増進やフィットネスプログラムを提供する仕事。',
    riasecProfile: { R: 30, I: 15, A: 10, S: 30, E: 10, C: 5 },
    requiredValues: ['社会貢献', '自己成長', '人間関係'],
    requiredSkills: ['コミュニケーション力', '計画力', '実行力'],
    basicAbilities: { teamworkLevel: 4, goalAchievementLevel: 4, mentalToughnessLevel: 3, growthMindsetLevel: 5, leadershipLevel: 3 },
    athleteFriendly: true,
    careerPath: 'トレーナー → チーフトレーナー → 健康推進マネージャー',
    averageSalary: '350-600万円',
    requiredEducation: '大卒以上、トレーナー資格推奨',
    growthPotential: 'medium',
  },
];

export default sampleCareers;